const PathToSubmissionTestIdsScope = {
  PATH_TO_SUBMISSION: 'path-to-submission',
  NEXT_ACTION_CALLOUT: 'next-action-callout',
  SUBMISSION_STEP_ROW: 'submission-step-row',
  STEP_NODE: 'step-node',
};

export const PathToSubmissionTestIds = {
  // PathToSubmission
  TERMINAL_ACTION_BUTTON: `${PathToSubmissionTestIdsScope.PATH_TO_SUBMISSION}.terminal-action-button`,
  TOGGLE_BUTTON: `${PathToSubmissionTestIdsScope.PATH_TO_SUBMISSION}.toggle-button`,
  LOADING_SKELETON: `${PathToSubmissionTestIdsScope.PATH_TO_SUBMISSION}.loading-skeleton`,

  // NextActionCallout
  NEXT_ACTION_PRIMARY_BUTTON: `${PathToSubmissionTestIdsScope.NEXT_ACTION_CALLOUT}.primary-button`,
  NEXT_ACTION_SECONDARY_BUTTON: `${PathToSubmissionTestIdsScope.NEXT_ACTION_CALLOUT}.secondary-button`,
  CALLOUT_CHIPS_ROW: `${PathToSubmissionTestIdsScope.NEXT_ACTION_CALLOUT}.chips-row`,

  // SubmissionStepRow
  SUBMISSION_STEP_ROW_CTA_BUTTON: `${PathToSubmissionTestIdsScope.SUBMISSION_STEP_ROW}.cta-button`,

  // StepNode
  getStepNodeId: stepKey => `${PathToSubmissionTestIdsScope.STEP_NODE}.${stepKey}`,
};
